import { reactive } from "vue";

import { Routes } from "@/enums/routes";
import { IState } from "@/interfaces/state.interface";
import { IQuestion } from "@/interfaces/questions.interface";

import questions from '@/../static/data/questions.json';

const state: IState = reactive({
	router: {
		current: Routes.HOME,
		props: []
	},
	portal: null,
	userName: '',
	questions: (questions.config as IQuestion[]).slice(),
	results: {
		threeLetterCode: '',
		personalityTypes: [],
		disciplines: []
	},
	isLoggedIn: false,
	preferredPortalType: null
});

export default state;